var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_1192",
    "data-name": "Component 11 \\u2013 1192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 19,
    height: 19,
    fill: "#6a6f73"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_19",
    "data-name": "Mask Group 19",
    clipPath: "url(#heart)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_12_",
    "data-name": "svgexport-6 (12)",
    transform: "translate(0 0.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5334",
    "data-name": "Path 5334",
    d: "M17.446,2.367a5.192,5.192,0,0,0-7.609,0L9.5,2.721l-.335-.354A5.2,5.2,0,0,0,1.824,2.1q-.14.13-.27.27a5.827,5.827,0,0,0,0,7.923l7.455,7.861a.679.679,0,0,0,.96.026l.026-.026,7.452-7.861A5.826,5.826,0,0,0,17.446,2.367Zm-.983,6.987h0L9.5,16.7,2.539,9.355a4.453,4.453,0,0,1,0-6.054,3.838,3.838,0,0,1,5.423-.218q.113.1.218.218l.828.873a.7.7,0,0,0,.986,0l.828-.873a3.838,3.838,0,0,1,5.423-.218q.113.1.218.218A4.412,4.412,0,0,1,16.464,9.355Z",
    transform: "translate(0 -0.708)",
    fill: "#6a6f73"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.7d78c5e9573fbfd6e54dbaac0d801215.svg";
export { ForwardRef as ReactComponent };